import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import getRequestApprovalById from 'Api/reschedule/getRequestApprovalById';
import getRequestApprovalByIdRequest from './model/request/getRequestApprovalByIdRequest';
import getRequestApprovalByIdResponse from './model/response/getRequestApprovalByIdResponse';

const useGetRequestApprovalById = () => {
  const { id } = useParams();

  return useQuery({
    queryKey: ['request-approval-by-id', id],
    queryFn: async () => {
      const requestId = getRequestApprovalByIdRequest(id);

      const response = await getRequestApprovalById(requestId);

      const result = getRequestApprovalByIdResponse(response);

      return result;
    },

    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRequestApprovalById;
